import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getCurrentMonthActivities = (CompanyId) => {
    return vdkEmHappinessPortalApi.post(`/get-current-month-people-activities`, CompanyId);
};
const getPeopleActivitiesDashboard = (CompanyId) => {
    return vdkEmHappinessPortalApi.post(`/get-people-activities-dashboard`, CompanyId);
};
const getPeopleMonthlyActivitiesForDashboardsAndCalendar = (query) => {
    return vdkEmHappinessPortalApi.post('/get-people-monthly-activities-for-dashboards-and-calendar', query);
};
const getActivityById = (activityId) => {
    return vdkEmHappinessPortalApi.get(`/people-activities/${activityId}`);
};
const getPeopleActivitiesByPersonId = (personId) => {
    return vdkEmHappinessPortalApi.get(`/get-people-activities-by-personId/${personId}`);
};
const peopleActivitiesAPI = {
    getCurrentMonthActivities,
    getPeopleActivitiesDashboard,
    getActivityById,
    getPeopleMonthlyActivitiesForDashboardsAndCalendar,
    getPeopleActivitiesByPersonId
};
export default peopleActivitiesAPI;
